module.exports = __webpack_public_path__ + "static/9-ea673a6f42d4897289d06e6bcf26f310.jpg";